import React, { useEffect, useState } from "react";
import { Spinner } from "@flixbus/honeycomb-react";
import styles from "./DelayedSpinner.module.scss";

export const spinnerDelayMs = 250;

interface DelayedSpinnerProps {
  delayMs?: number;
}

const DelayedSpinner: React.FC<DelayedSpinnerProps> = ({
  delayMs = spinnerDelayMs,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  if (!visible) return null;

  return (
    <div
      className={styles.loading}
      role="status"
      aria-busy="true"
      aria-label="Loading"
    >
      <Spinner />
    </div>
  );
};

export default DelayedSpinner;
